/**
 * @generated SignedSource<<988ae6fa0c7bfb53061547b401034a78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InsertTemplatePreviewQuery$variables = {
  projectId?: string | null;
  baselineTemplateId: string;
};
export type InsertTemplatePreviewQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly baselineTemplatePreview: {
        readonly name: string | null;
        readonly description: string | null;
        readonly includeDeliverables: boolean | null;
        readonly usageCount: number | null;
        readonly updatedAt: string | null;
        readonly createdBy: {
          readonly fullName: string | null;
        } | null;
        readonly totalMinutes: number | null;
        readonly roleCount: number | null;
        readonly deliverableCount: number | null;
        readonly durationDays: number | null;
        readonly phases: ReadonlyArray<{
          readonly name: string | null;
          readonly startWeek: number | null;
          readonly durationDays: number | null;
          readonly totalMinutes: number | null;
          readonly expenseCount: number | null;
          readonly timeEstimates: ReadonlyArray<{
            readonly roleName: string | null;
            readonly minutes: number | null;
          } | null> | null;
          readonly deliverables: ReadonlyArray<{
            readonly name: string | null;
            readonly totalMinutes: number | null;
            readonly expenseCount: number | null;
            readonly timeEstimates: ReadonlyArray<{
              readonly roleName: string | null;
              readonly minutes: number | null;
            } | null> | null;
          } | null> | null;
          readonly noDeliverable: {
            readonly name: string | null;
            readonly totalMinutes: number | null;
            readonly expenseCount: number | null;
            readonly timeEstimates: ReadonlyArray<{
              readonly roleName: string | null;
              readonly minutes: number | null;
            } | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type InsertTemplatePreviewQuery = {
  variables: InsertTemplatePreviewQuery$variables;
  response: InsertTemplatePreviewQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineTemplateId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "baselineTemplateId",
    "variableName": "baselineTemplateId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeDeliverables",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutes",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverableCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationDays",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "BaselineTemplatePreviewTimeEstimate",
  "kind": "LinkedField",
  "name": "timeEstimates",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v4/*: any*/),
  (v10/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "BaselineTemplatePreviewPhase",
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startWeek",
      "storageKey": null
    },
    (v13/*: any*/),
    (v10/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineTemplatePreviewGroup",
      "kind": "LinkedField",
      "name": "deliverables",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineTemplatePreviewGroup",
      "kind": "LinkedField",
      "name": "noDeliverable",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InsertTemplatePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "BaselineTemplatePreview",
                "kind": "LinkedField",
                "name": "baselineTemplatePreview",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InsertTemplatePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "BaselineTemplatePreview",
                "kind": "LinkedField",
                "name": "baselineTemplatePreview",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0574a67c04618d66acefb1816d13e80e",
    "id": null,
    "metadata": {},
    "name": "InsertTemplatePreviewQuery",
    "operationKind": "query",
    "text": "query InsertTemplatePreviewQuery(\n  $projectId: ID\n  $baselineTemplateId: ID!\n) {\n  viewer {\n    project(internalId: $projectId) {\n      baselineTemplatePreview(baselineTemplateId: $baselineTemplateId) {\n        name\n        description\n        includeDeliverables\n        usageCount\n        updatedAt\n        createdBy {\n          fullName\n          id\n        }\n        totalMinutes\n        roleCount\n        deliverableCount\n        durationDays\n        phases {\n          name\n          startWeek\n          durationDays\n          totalMinutes\n          expenseCount\n          timeEstimates {\n            roleName\n            minutes\n          }\n          deliverables {\n            name\n            totalMinutes\n            expenseCount\n            timeEstimates {\n              roleName\n              minutes\n            }\n          }\n          noDeliverable {\n            name\n            totalMinutes\n            expenseCount\n            timeEstimates {\n              roleName\n              minutes\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb6ce55abbe64f2d21b7a405c500ace0";

export default node;
